import './App.css';
import React from 'react';

function Main(){
return(
    <div className='main'>
        <h3 className='about'>About</h3>
        <p className='about-para'>A passionate Computer Science engineer, seeking an entry level position in a dynamic organization, preferably in the field of Application Development, with special interests in areas like Machine Learning, Front End Development, and related fields, resulting in meaningful contribution towards organizational growth along with personal and professional development.
        </p>
        <h3 className='interests'>Interests</h3>
         <p className='interests-para'>Bharthanatyam Dancer, Carnatic Singer, Doodler.</p>
    </div>
)
}
export default Main;